import { normalizeQuantity } from "./normalizeQuantity";


export function normalizeParentQuantity(parent) {
  return {
    nodeId: `p${parent.id}`,
    id: parent.id,
    type: "parent",

    title: parent.title,
    code: parent.code,
    goldType: parent.gold_type,
    isDirect: false,
    conversionFactor: parent.conversion_factor,
    prices: {
      buy: parent.buy_price,
      sell: parent.sell_price,
    },

    steps: {
      buy: {
        value: parent?.buy_step?.value || null,
        scope: parent?.buy_step?.scope || null,
      },
      sell: {
        value: parent?.sell_step?.value || null,
        scope: parent?.sell_step?.scope || null,
      },
    },

    active: {
      buy: {
        id: parent.buy_price_is_active?.id,
        isActive: parent.buy_price_is_active?.is_active,
      },
      sell: {
        id: parent.sell_price_is_active?.id,
        isActive: parent.sell_price_is_active?.is_active,
      },
    },

    // quantityDefinitions: (parent.quantity_definitions || []).map(normalizeQuantity),
    quantityDefinitions: [],

    canEditPrice: true,
    hasMapping: false,

    isActive: parent.is_active,
  };
}